export default "__VITE_ASSET__Cym90kMf__"